import { Activity, Box, Code2, Cpu, FileDown, Trophy } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import type { Bilingual } from '../i18n/LanguageContext';

export interface Feature {
  icon: LucideIcon;
  label: Bilingual;
}

export const features: Feature[] = [
  { icon: Cpu, label: { en: 'Build Circuits', ar: 'ابنِ الدوائر' } },
  { icon: Code2, label: { en: 'Code Robots', ar: 'برمج الروبوتات' } },
  { icon: Activity, label: { en: 'Run Simulations', ar: 'شغّل المحاكاة' } },
  { icon: Box, label: { en: '3D Builder', ar: 'منشئ ثلاثي الأبعاد' } },
  { icon: Trophy, label: { en: 'Leaderboards', ar: 'لوحات الصدارة' } },
  { icon: FileDown, label: { en: 'Export Prototype Plans', ar: 'صدّر خطط النماذج' } },
];
